import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";

var ZipCityCounty =
/*#__PURE__*/
function () {
  function ZipCityCounty() {
    _classCallCheck(this, ZipCityCounty);
  }

  _createClass(ZipCityCounty, null, [{
    key: "isLocationInAMRS",
    value: function isLocationInAMRS(cityId, countyId, zipId) {
      return axios.get("api/ZipCityCounty/IsLocationInAMRS/".concat(cityId, "/").concat(countyId, "/").concat(zipId));
    }
  }, {
    key: "addNewLocation",
    value: function addNewLocation(cityId, countyId, zipId) {
      return axios.post("api/ZipCityCounty/AddNewLocation/".concat(cityId, "/").concat(countyId, "/").concat(zipId));
    }
  }]);

  return ZipCityCounty;
}();

export { ZipCityCounty as default };